import React from "react";
import dayjs, { Dayjs } from "dayjs";
import sharedConfig, { TLang } from "_configs/sharedConfig";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import styles from "./_css/blogCard.module.css";
import clsx from "clsx";
import { BLOG_TYPE } from "pages/_models/PageMdl";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

type Props = {
    variant: "featured" | "compact";
    blogType?: BLOG_TYPE;
    date?: Dayjs | string;
    title?: string;
    text?: string;
    image?: string;
    url?: string;
};

export function BlogCard(props: Props) {
    const lang = i18next.language;
    const { t } = useTranslation();

    const href = sharedConfig.languages[lang as TLang].baseUrl + "/" + t("routes.blog") + props.url;

    const dateLabel = props.date
        ? `${t("dates.monthOfYearShort." + dayjs(props.date).format("M"))} ${dayjs(props.date).format("YYYY")}`
        : null;

    const categoryLabel = props.blogType
        ? t([`homePage.blog.types.${props.blogType.replace(/ /g, "_")}`, props.blogType])
        : null;

    const readLabel = props.variant === "featured" ? t("homePage.blog.readArticle") : t("homePage.blog.read");

    if (props.variant === "featured") {
        return (
            <a className={clsx(styles.featured)} href={href}>
                <div className={styles.featuredImage} style={{ backgroundImage: `url(${props.image})` }} />
                <div className={styles.featuredOverlay} />
                {categoryLabel && <span className={clsx(styles.badge, styles.badgeOnImage)}>{categoryLabel}</span>}
                <div className={styles.featuredContent}>
                    <h3 className={styles.featuredTitle}>{props.title}</h3>
                    <p className={styles.featuredText}>{props.text}</p>
                    <div className={styles.featuredFooter}>
                        {dateLabel && <span className={styles.date}>{dateLabel}</span>}
                        <span className={styles.readLink}>
                            {readLabel}
                            <ArrowRightAltIcon className={styles.readArrow} />
                        </span>
                    </div>
                </div>
            </a>
        );
    }

    return (
        <a className={styles.compact} href={href}>
            <div className={styles.compactImage} style={{ backgroundImage: `url(${props.image})` }} />
            <div className={styles.compactContent}>
                {categoryLabel && <span className={clsx(styles.badge, styles.badgeSoft)}>{categoryLabel}</span>}
                <h3 className={styles.compactTitle}>{props.title}</h3>
                <p className={styles.compactText}>{props.text}</p>
                <div className={styles.compactFooter}>
                    {dateLabel && <span className={styles.date}>{dateLabel}</span>}
                    <span className={styles.readLink}>
                        {readLabel}
                        <ArrowRightAltIcon className={styles.readArrow} />
                    </span>
                </div>
            </div>
        </a>
    );
}
